import React, { useState } from 'react';
import Facebook from '../../Images/facebook.png'
import Telegram from '../../Images/telegram.webp'
import Instagram from '../../Images/instagram.png'
import './SocialNetwork.css'

const SocialNetwork = () => {

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [loading, setLoading] = useState(false)

    const handleOpen = () => {
        setIsModalOpen(x=>!x)
    }


    return (
        <div>
            <h4 className="confirm-lesson-title">Social Networks</h4>
            <div className="social-block">
                <div onClick={handleOpen} className="social-card">
                    <img className='social-img' src={Facebook} alt="facebook" />
                    <h4 className="social-title">Facebook</h4>
                </div>
                <div className="social-card">
                    <img className='social-img' src={Telegram} alt="telegram" />
                    <h4 className="social-title">Telegram</h4>
                </div>
                <div className="social-card">
                    <img className='social-img' src={Instagram} alt="instagram" />
                    <h4 className="social-title">Instagram</h4>
                </div>
            </div>

            {isModalOpen && (
                <div className="add-certificate-input"
                    style={{ marginBottom: "0px", width: "100%", }}>
                    <div className="certificate-modal">
                        <h3>Enter your social media address:</h3>
                        <label className="social-label">
                            <input placeholder='social media address...' type="text" />
                        </label>
                        <div className="form-modal-footer certificate-btn">
                            <button onClick={handleOpen} className="form-cancel-btn">
                                Cancel
                            </button>
                            <button type="submit" className="form-confirm-btn" disabled={loading} >
                                {loading ? "Loading..." : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default SocialNetwork;
